import styled, { keyframes, createGlobalStyle } from 'styled-components';

export const AnnotationGlobalStyles = createGlobalStyle`
  .zone-label-tooltip {
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 11px;
    font-weight: 700;
    color: #1f2937;
    padding: 0;
    pointer-events: none;
  }
  .zone-label-tooltip::before { display: none; }
`;

const slideIn = keyframes`
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
`;

export const AnnotationToolbarWrap = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  pointer-events: none;

  * { pointer-events: all; }
`;

export const ToolbarButtons = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 0 12px rgba(0,0,0,0.15);
  overflow: hidden;
  width: 48px;
`;

export const ToolbarBtn = styled.button`
  width: 48px;
  height: 48px;
  border: none;
  background: ${({ active }) => active ? '#0d3825' : 'white'};
  color: ${({ active }) => active ? 'white' : '#374151'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background 0.15s, color 0.15s;
  border-bottom: 1px solid #f0f0f0;

  &:last-child { border-bottom: none; }

  svg {
    width: 22px;
    height: 22px;
  }

  &:hover {
    background: ${({ active }) => active ? '#0d3825' : '#f3f4f6'};
  }

  &:hover .toolbar-tooltip {
    opacity: 1;
    pointer-events: none;
  }
`;

export const Tooltip = styled.span`
  position: absolute;
  right: 54px;
  white-space: nowrap;
  background: rgba(0,0,0,0.78);
  color: white;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
`;

export const AnnotationPanelWrap = styled.div`
  width: 288px;
  background: white;
  box-shadow: -4px 0 20px rgba(0,0,0,0.12);
  display: flex;
  flex-direction: column;
  max-height: 520px;
  border-radius: 8px 0 0 8px;
  animation: ${slideIn} 0.2s ease;
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  padding: 14px 16px 10px;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: #6b7280;
    font-size: 16px;
    padding: 0;
    line-height: 1;
    &:hover { color: #111; }
  }
`;

export const IconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  padding: 12px;
  overflow-y: auto;
  flex: 1;
`;

export const IconCell = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  padding: 8px 4px 6px;
  background: ${({ active }) => active ? '#f0fdf4' : 'transparent'};
  border: ${({ active }) => active ? '2px solid #0d3825' : '2px solid transparent'};
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  img, svg {
    width: 36px;
    height: 36px;
  }

  span {
    font-size: 9px;
    color: #374151;
    text-align: center;
    line-height: 1.2;
    max-width: 56px;
  }
`;

export const AnnotationsSidebarSection = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;

  h4 {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 10px 0;
  }
`;

export const DrawingControlBar = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1200;
  display: flex;
  gap: 8px;
  background: white;
  padding: 8px 14px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  align-items: center;
  font-size: 13px;
  color: #374151;
`;

export const CategoryToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  cursor: pointer;

  input[type="checkbox"] {
    accent-color: #0d3825;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  span {
    font-size: 13px;
    color: #374151;
  }
`;
